import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  pb: (p) => p.spacing(4),
};

export const content: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: (p) => p.spacing(2),
  flexGrow: 0,
};

export const box: SxStyle = {
  display: 'flex !important',
  flexDirection: 'column',
  justifyContent: 'space-between',
  maxWidth: (p) => p.spacing(33),
  height: (p) => p.spacing(40.5),
  padding: (p) => p.spacing(2),
  borderWidth: (p) => p.spacing(0.5),
  borderStyle: 'solid',
  borderColor: (p) => p.palette.primary[200],
  borderRadius: (p) => p.spacing(1.5),
};
